import React from 'react';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import styled from 'styled-components';
import { useFlags } from 'launchdarkly-react-client-sdk';

import { TwoColumn, TwoColumnContent } from 'components/layouts/two-column';
import { OneColumn, OneColumnContent } from 'components/layouts/one-column';

import { Header } from 'src/dispensary/core-menu/components/header';
import CoreMenuHeader from 'src/dispensary/core-menu/components/core-menu-header';
import StoreInfo from 'src/dispensary/components/store-info';
import MetaTags from 'components/meta-tags';
import { DutchiePrivacyFooter } from 'src/dispensary/core-menu/components/dutchie-privacy-footer';
import Wrapper from 'components/wrapper';
import useDispensary from 'src/dispensary/hooks/use-dispensary';
import { MainContent } from 'components/skip-to-main';

export default function CoreMenuInfoPage() {
  const { dispensary } = useDispensary();
  const isDesktopMenuSize = useMediaQuery((theme) => theme.breakpoints.up(`md`));
  // eslint-disable-next-line no-use-before-define
  const ColumnLayout = isDesktopMenuSize ? OneColumn : TwoColumn;
  const ContentLayout = isDesktopMenuSize ? OneColumnContent : TwoColumnContent;

  const flags = useFlags();
  const isNewEmbeddedHeaderFlagEnabled = flags['growth.ecomm.embedded-header.rollout'] ?? false;

  if (!dispensary) {
    return null;
  }

  return (
    <Wrapper>
      <MetaTags />
      {isNewEmbeddedHeaderFlagEnabled ? <Header dispensary={dispensary} /> : <CoreMenuHeader dispensary={dispensary} />}
      <ColumnLayout>
        <Container>
          <ContentLayout>
            <StyledMainContent>
              <StoreInfo dispensary={dispensary} />
            </StyledMainContent>
          </ContentLayout>
        </Container>
      </ColumnLayout>
      <DutchiePrivacyFooter />
    </Wrapper>
  );
}

const Container = styled.div`
  width: 100%;
`;

const StyledMainContent = styled(MainContent)`
  ${({ theme }) => theme.breakpoints.down(`sm`)} {
    padding: unset;
  }
`;
